"use client";

import React, { useState, type MouseEvent, useMemo, Fragment } from "react";

import AdapterLinkButton from "@/components/Adapter/LinkButton";
import Web3Balance from "@/components/Web3/Balance";
import Web3TotalPortfolio from "@/components/Web3/TotalPortfolio";

import { useAuthenticateConnectedUser, useDynamicContext } from "@dynamic-labs/sdk-react-core";
import { SupButton, SupChip, SupLoader, SupPopover } from "@repo/core-ui";
import { SupCheckCircle, SupLock, SupRightArrowAlt, SupWallet } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

export default function LayoutMenuWallet() {
  const { authenticateUser, isAuthenticating } = useAuthenticateConnectedUser();
  const { primaryWallet, user, setShowDynamicUserProfile } = useDynamicContext();

  /**
   * Props for the Popover
   */
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const isOpened = useMemo(() => {
    return Boolean(anchorEl);
  }, [anchorEl]);

  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Fragment>
      <button
        id="deposit-handler"
        onClick={(event: MouseEvent<HTMLElement>) => setAnchorEl(anchorEl ? null : event.currentTarget)}
        type="button"
        className={twMerge("btn-icon h-10 w-10 hover:bg-primary-75 hover:text-neutral-950", isOpened && "opened")}
      >
        <span className="sr-only">Wallet</span>
        <SupWallet className="stroke-0" />
      </button>
      <SupPopover offset={[0, 4]} className="sup-tx-popup" open={isOpened} anchorEl={anchorEl} onClickOutside={handleClose}>
        <header className="relative -ml-2 flex items-center justify-between">
          <SupButton
            variant="outlined"
            className="h-8 border-none px-1 py-3 hover:bg-primary-200/20"
            prefixIcon={<SupWallet className="h-5 w-5" />}
            onClick={() => {
              handleClose();
              setShowDynamicUserProfile(true);
            }}
          >
            {primaryWallet && (
              <span className="normal-case">
                {primaryWallet.address.substring(0, 7)}...{primaryWallet.address.slice(-5)}
              </span>
            )}
          </SupButton>
          {user ? (
            <SupChip active icon={<SupCheckCircle className="h-6 w-6" />} label="Authenticated" small variant="success" />
          ) : (
            <SupButton
              variant="outlined"
              className="h-8 px-1.5 py-3 hover:bg-success-200"
              color="success"
              disabled={isAuthenticating}
              prefixIcon={isAuthenticating ? <SupLoader isSmall /> : <SupLock className="h-5 w-5" />}
              onClick={authenticateUser}
            >
              Authenticate
            </SupButton>
          )}
        </header>

        <Web3TotalPortfolio />

        <Web3Balance showChains={false} strategy="fully-cached" />
        <AdapterLinkButton
          href="/portfolio"
          onClick={handleClose}
          className="justify-center"
          buttonProps={{
            fluid: true,
            suffixIcon: <SupRightArrowAlt />,
          }}
        >
          View Portfolio
        </AdapterLinkButton>
      </SupPopover>
    </Fragment>
  );
}
